import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative z-[1]" }
const _hoisted_2 = { class: "absolute top-0 left-1/2 -translate-x-1/2 hidden group-hover/navItem:block" }
const _hoisted_3 = { class: "bg-neutral2-100 rounded-lg inline-block font-semibold border border-tile-border shadow-md" }
const _hoisted_4 = { class: "bg-neutral2-050 text-neutral2-600 text-xs py-3 px-4 space-x-4 rounded-t-lg border-b border-tile-border" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "p-4" }
const _hoisted_7 = { class: "flex gap-x-6" }
const _hoisted_8 = { class: "text-neutral2-800 whitespace-nowrap" }
const _hoisted_9 = ["href", "textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "text-sm whitespace-nowrap" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  key: 0,
  class: "ml-1 text-xs text-[#ebb305]",
  title: "Promowana kategoria."
}
const _hoisted_15 = {
  key: 1,
  class: "ml-1 text-xs text-green-500",
  title: "Kategoria o wzrastającej popularności."
}
const _hoisted_16 = ["textContent"]
const _hoisted_17 = {
  key: 0,
  class: "font-normal whitespace-nowrap relative"
}
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "bg-neutral2-050 text-neutral2-600 text-xs py-3 px-4 space-x-4 rounded-b-lg border-t border-tile-border"
}
const _hoisted_21 = ["href", "title", "textContent"]

import {computed} from "vue";
import Icon from "../../../Icon/Icon.vue";
import {NavigationForumMenu} from "../../NavigationForumMenu";
import {useNavigationStore} from "../navigationStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ForumMenuDesktop',
  setup(__props) {

const store = useNavigationStore();

const forumMenu = computed<NavigationForumMenu>(() => store.$state.navigationForumMenu!);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forumMenu.value.headerItems, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              title: item.help
            }, [
              _createVNode(Icon, {
                name: item.icon,
                class: _normalizeClass(["mr-1", {'text-green-500':item.online}])
              }, null, 8 /* PROPS */, ["name", "class"]),
              _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_5))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forumMenu.value.sections, (category) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(Icon, {
                    name: category.icon,
                    class: "mr-2"
                  }, null, 8 /* PROPS */, ["name"]),
                  (category.href)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: category.href,
                        textContent: _toDisplayString(category.title)
                      }, null, 8 /* PROPS */, _hoisted_9))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        textContent: _toDisplayString(category.title)
                      }, null, 8 /* PROPS */, _hoisted_10))
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "text-tile-border mt-1 mb-1.5" }, null, -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "flex justify-between gap-15 py-1.5 text-neutral2-500 text-xs group/item",
                    href: item.href
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", {
                          class: "group-hover/item:text-green2-600 font-medium",
                          textContent: _toDisplayString(item.title)
                        }, null, 8 /* PROPS */, _hoisted_13),
                        (item.promoted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createVNode(Icon, { name: "navigationCategoryPromoted" })
                            ]))
                          : _createCommentVNode("v-if", true),
                        (item.trending)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              _createVNode(Icon, { name: "navigationCategoryTrending" })
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (item.subtitle)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "font-normal whitespace-nowrap text-neutral2-400 group-hover/item:text-neutral2-500",
                            textContent: _toDisplayString(item.subtitle)
                          }, null, 8 /* PROPS */, _hoisted_16))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (item.count)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createTextVNode(_toDisplayString(item.count.short) + " ", 1 /* TEXT */),
                          _createElementVNode("span", {
                            class: "absolute right-0 bg-neutral2-100 overflow-hidden transition-[max-width] max-w-0 group-hover/item:max-w-25",
                            textContent: _toDisplayString(item.count.long)
                          }, null, 8 /* PROPS */, _hoisted_18)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_11))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("a", {
            class: "block text-green-500 text-sm mt-6",
            href: forumMenu.value.allCategoriesHref
          }, [
            _cache[1] || (_cache[1] = _createTextVNode(" Zobacz wszystkie kategorie ")),
            _createVNode(Icon, {
              name: "navigationAllCategories",
              class: "ml-1"
            })
          ], 8 /* PROPS */, _hoisted_19)
        ]),
        (forumMenu.value.footerItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forumMenu.value.footerItems, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  href: item.href,
                  title: item.help,
                  textContent: _toDisplayString(item.title)
                }, null, 8 /* PROPS */, _hoisted_21))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})